import { render, staticRenderFns } from "./SkillEditorDetails.vue?vue&type=template&id=1d34b981"
import script from "./SkillEditorDetails.vue?vue&type=script&lang=js"
export * from "./SkillEditorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports